import { Injectable } from '@angular/core';

import { map, mergeMap, of } from 'rxjs';

import { Structure, StructureControllerService } from '@bms-client/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { createAction, createReducer, on, props, Store } from '@ngrx/store';

import { IAppState } from '../../index';

export const loadStructures = createAction('[App Component] Load structures');
export const loadStructuresSuccess = createAction('[Structure Effect] Load structures SUCCESS', props<{ structures: Structure[] }>());
export const NO_OP_CACHE = createAction('[Structure Effect] No operation: cache');

export const clearCurrentStructureTree = createAction('[Structure Effect] Clear structures');

export interface IStructureState {
    structures: Structure[];
}

export const initialState: IStructureState = {
    structures: [],
};

export const currentStructureTreeReducer = createReducer(
    initialState,
    on(loadStructures, (state): IStructureState => ({ ...state, structures: state.structures })),
    on(loadStructuresSuccess, (state, { structures }) => ({
        ...state,
        structures: structures,
    })),
    on(NO_OP_CACHE, (state): IStructureState => ({ ...state })),

    // clearing
    on(clearCurrentStructureTree, () => initialState),
);

@Injectable()
export class StructureTreeEffects {
    loadStructures$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadStructures),
            concatLatestFrom(() => this.store.select((s) => s.currentStructureTree.structures)),
            mergeMap(([, structures]) => {
                return structures?.length === 0
                    ? this.structureControllerService.getStructureByMandatorId().pipe(
                          //
                          map((structures) => loadStructuresSuccess({ structures })),
                      )
                    : of(NO_OP_CACHE());
            }),
        );
    });

    constructor(private actions$: Actions, private store: Store<IAppState>, private structureControllerService: StructureControllerService) {}
}
